export default {"detailProfileDataStyled":"NDJpS","popupDetailProfileDataItem":"-HYc6","profileDataItemIcon":"CqAo0","profileDataItemText":"zGqUm"};